/* X-GIRI 18/10/2026. Page «Giri»: an image of a strip gets its real srcset only when it enters the visible part of the strip (a card hidden
   to the side of its strip does not count as visible), 300 px ahead vertically. Without IntersectionObserver everything loads at once. */
(() => {
  const imgs = document.querySelectorAll('.bh-q4g img[data-na-srcset]');
  if (!imgs.length) return;
  const vai = (i) => { i.srcset = i.dataset.naSrcset; i.src = i.dataset.naSrc; i.removeAttribute('data-na-srcset'); };
  if (!('IntersectionObserver' in window)) { imgs.forEach(vai); return; }
  const o = new IntersectionObserver((voci) => {
    for (const v of voci) if (v.isIntersecting) { vai(v.target); o.unobserve(v.target); }
  }, { rootMargin: '300px 0px' });
  imgs.forEach((i) => o.observe(i));
})();
